<template>
  <v-container class="grey lighten-5">
    <v-row dense justify="center">
     <v-col cols="12" md="10" dense>
        <div>
        <v-btn icon :to="{ path: '/employeelist' }">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="display-1 px-3">担当者情報</span>
        </div>
     </v-col>
    </v-row>
    <v-row dense justify="center">
      <v-col cols="12" md="10" dense>

          <v-card v-if= "!isAdmin" flat outlined class="ma-5 pa-3">
            <div class="subtitle-2 mb-2">
              <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
              <span class="primary--text">担当者管理機能について</span>
            </div>
            <p class="caption">
              担当者管理機能は、管理者権限をお持ちの方のみご利用いただけます。<br>
              この機能をご利用になりたい場合は、事業所の管理者様にご連絡してください。<br>
            </p>
          </v-card>

          <v-card v-else class="pb-10">
            <v-card-title>{{ employee.Name }} 様
              <v-chip v-show="!isUserPooled" class="caption mx-2 mb-1" color="teal darken-1 white--text" x-small>許可済</v-chip>
              <div class="caption">{{ employee.id }}</div>
            </v-card-title>
            <v-divider></v-divider>
            <div class="pa-3">
              <v-row dense>
                <v-col cols="12" class="mb-2">
                  <v-chip label outlined class="caption mr-2 mb-1" color="gray" small>会社名</v-chip><br>
                  <span class="body-1 ml-2">{{ employee.CompanyName }}</span>
                </v-col>
                <v-col cols="6" class="mb-2">
                  <v-chip label outlined  class="caption mr-2 mb-1" color="gray" small>事業所名</v-chip><br>
                  <span class="body-1 ml-2">{{ employee.OfficeName }}</span>
                </v-col>
                <v-col cols="6" class="mb-2">
                  <v-chip label outlined class="caption mr-2 mb-1" color="gray" small>部署名</v-chip><br>
                  <span class="body-1 ml-2">{{ employee.DeptName }}</span>
                </v-col>
                <v-col cols="12" class="mb-2" v-show="employee.Position">
                  <v-chip label outlined class="caption mr-2 mb-1" color="gray" small>役職</v-chip><br>
                  <span class="body-1 ml-2">{{ employee.Position }}</span>
                </v-col>
                <v-col cols="6" class="mb-2">
                  <v-chip label outlined class="caption mr-2 mb-1" color="gray" small>電話番号</v-chip><br>
                  <span class="body-1 ml-2">{{ employee.Tel }}</span>
                </v-col>
                <v-col cols="6" class="mb-2">
                  <v-chip label outlined class="caption mr-2 mb-1" color="gray" small>携帯電話番号</v-chip><br>
                  <span class="body-1 ml-2">{{ employee.Mobile }}</span>
                </v-col>
                <v-col cols="12" class="mb-2">
                  <v-chip label outlined class="caption mr-2 mb-1" color="gray" small>メールアドレス</v-chip><br>
                  <span class="body-1 ml-2">{{ employee.email }}</span>
                  <v-btn
                    class="ma-5 pa-3"
                    color="grey darken-4"
                    outlined
                    x-small
                    rounded
                    :disabled="!isUserAdmin"
                    @click="isResendConfirmed = true"
                  >
                  本人確認コードを再送
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <v-card v-if="isUserPooled" flat outlined class="ma-5 pa-3">
              <div class="subtitle-2 mb-2">
                <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                <span class="primary--text">サービスの利用許可について</span>
              </div>
              <p class="caption">
                      サービスの利用許可には、担当者様ご本人による本登録が必要となります。<br>
                      <br>
                      サービスの利用を許可すると、初期パスワードが発行されます。<br>
                      合わせて、システムから担当者様のメールアドレスに本人確認コードを送信します。<br>
                      初期パスワードと本人確認コードで担当者様の本人確認を行っていただきます。<br>
                      本人確認コードの有効期限は24と時間なっておりますので、担当者様に事前にご連絡いただきますようお願いいたします。<br>
                      <br>
                      登録済みのメールアドレスを変更する場合はジャパン・アナリストにご連絡してください。<br>
                      <br>
                      OilMatrix の利用を許可するには管理者権限が必要です。<br>
                      管理者権限が必要な場合はジャパン・アナリストの管理者に連絡してください。
              </p>
            </v-card>

            <div v-if= "isUserPooled" class="text-center">
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" rounded color="amber" :disabled="!isUserAdmin" @click="isConfirmed=true" data-signupUser class="mx-auto" style="text-transform: none;"><v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>OilMatrixの利用を許可</v-btn>
                </template>
                <span>サービス利用許可の確認画面が開きます</span>
              </v-tooltip>

            </div>
            
            <v-divider v-show="!isUserPooled"></v-divider>
            <v-card v-show="!isUserPooled" flat>
              <v-row dense>
                <v-col v-if="doChangeRole" cols="12" class="mb-2" dense>
                  <div class="pa-2 mb-1 ml-2">担当者の権限変更</div>
                  <v-row dense>
                    <v-col cols=2 class="text-right pt-2">
                      権限：
                    </v-col>
                    <v-col cols=4 >
                      <v-select v-model="role" :items="approvedRoles" item-value="Value" item-text="Text" dense 
                      ></v-select>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols=12 class="text-right pr-5">
                      <v-tooltip top color="grey darken-2">
                        <template v-slot:activator="{ on }">
                          <v-btn 
                            rounded 
                            v-on="on"
                            color="amber darken-3" 
                            @click="beforeUpdateRole()" 
                            class="px-2">
                              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                              権限を変更する
                          </v-btn> 
                        </template>
                        <span>ユーザーのサービス利用権限を変更します</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col v-else cols="12" class="mb-2">
                  <v-row dense>
                    <v-col cols="12">
                      <div class="pa-2 mb-1 ml-2">担当者の権限変更</div>
<!--
                      <v-chip class="caption mr-2 mb-1 ml-4" color="red white--text" small>システム管理者</v-chip>
-->
                      <span class="text-center mt-4 ml-4">
                        <v-icon color="red">mdi-alert-circle</v-icon>
                        権限を変更はできません。
                      </span>
                    </v-col>
                    <v-col cols=12 class="text-right pr-5">
                      <v-btn 
                        disabled
                        rounded 
                        color="amber darken-3" 
                        @click="beforeUpdateRole()" 
                        class="px-2">
                          <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                          権限を変更する
                      </v-btn> 
                    </v-col>
                  </v-row>
                  </v-col>                    
                </v-row>
                
                <v-row dense>
                  <!-- 担当者の部署異動セクション -->
                  <v-col v-if="doTranfer" cols="12" class="mb-2" dense>
                    <div class="pa-2 mb-1 ml-2">担当者の部署異動</div>
                    <v-row dense>
                      <v-col cols=12 class="text-right pr-5">
                        <v-tooltip top color="grey darken-2">
                          <template v-slot:activator="{ on }">
                            <v-btn 
                              rounded 
                              v-on="on"
                              color="amber darken-3" 
                              @click="beforeDeptTransfer()" 
                              class="px-2">
                                <v-icon class="mr-2">mdi-account-switch</v-icon>
                                部署異動する
                            </v-btn> 
                          </template>
                          <span>担当者の部署を変更します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-else cols="12" class="mb-2">
                    <v-row dense>
                      <v-col cols="12">
                        <div class="pa-2 mb-1 ml-2">担当者の部署異動</div>
  <!--
                        <v-chip class="caption mr-2 mb-1 ml-4" color="red white--text" small>システム管理者</v-chip>
  -->
                        <span class="text-center mt-4 ml-4">
                          <v-icon color="red">mdi-alert-circle</v-icon>
                          担当者の部署異動はできません。
                        </span>
                      </v-col>
                      <v-col cols=12 class="text-right pr-5">
                        <v-btn 
                          disabled
                          rounded 
                          color="amber darken-3" 
                          class="px-2">
                            <v-icon class="mr-2">mdi-account-switch</v-icon>
                            部署異動する
                        </v-btn> 
                      </v-col>
                    </v-row>
                  </v-col>                    

                </v-row>
              </v-card>
          </v-card>
          <v-overlay absolute :value="overlayStepper1" opacity="1.0" color="white" z-index="1">
            <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
          </v-overlay>
      </v-col>
    </v-row>


    <v-dialog
      v-model="isAllowConfirmed"
      persistent
      max-width="500"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline" id="card-title">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
          ご確認ください
          </v-card-title>
        <v-card-text class="caption">
          ユーザー「{{ employee.Name }}」の権限を
          <span class="teal--text text-darken-1 font-weight-bold">{{ rolename }}</span>
          に変更します。<br>
          「変更する」ボタンをクリックしてください
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            @click="isAllowConfirmed = false"
          >
          キャンセル
          </v-btn>
          <v-btn
            rounded 
            color="amber darken-1" 
            @click="updateRole()" 
            class="px-2"
            >
            <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
            変更する
          </v-btn> 
      </v-card-actions>
    </v-card>
    </v-dialog>

    <v-dialog
      v-model="isConfirmed"
      persistent
      max-width="500"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline" id="card-title">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
          ご確認ください
        </v-card-title>
        <v-card-text v-show="employee.email">
          <div class="body-3" style="margin-top: 10px ">
            サービスの利用を許可する担当者様のお名前<br>
          </div>
          <div class="body-1 black--text">
            {{ employee.Name }}様<br>
          </div>
          <div class="body-3" style="margin-top: 10px ">
            メールアドレス<br>
          </div>
          <div class="body-1 black--text">
            {{ employee.email }}<br>
          </div>

          <div class="body-3 black--text" style="margin-top: 20px ">
            <v-icon color="green darken-1">mdi-checkbox-marked-circle</v-icon>担当者様ご本人宛で本人確認コードがメールで送信されます。<br>
            <br>
            <v-icon color="red darken-1">mdi-alert-circle</v-icon>本人確認コードの有効期限は送信から24時間となっておりますのでご注意ください。<br>
            <br>
            ご利用を許可して、メールを送信してよろしいですか？<br>
          </div>
         </v-card-text>

         <v-card-text v-show="!employee.email">
          <div class="headline">
            <v-icon color="red darken-1">mdi-close-circle</v-icon>メールアドレスの登録がありません。
          </div>
         </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            @click="isConfirmed = false"
          >
          キャンセル
          </v-btn>
          <v-btn
            rounded 
            color="amber darken-1" 
            @click="signUp()" 
            class="px-2"
          >
          <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
          許可する
          </v-btn> 

      </v-card-actions>
    </v-card>
    </v-dialog>

    <v-dialog
      v-model="isResendConfirmed"
      persistent
      max-width="500"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline" id="card-title">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
          ご確認ください
        </v-card-title>
        <v-card-text v-show="employee.email">
          <div class="body-3" style="margin-top: 10px ">
            本人確認コードを再送する担当者様のお名前<br>
          </div>
          <div class="body-1 black--text">
            {{ employee.Name }}様<br>
          </div>
          <div class="body-3" style="margin-top: 10px ">
            メールアドレス<br>
          </div>
          <div class="body-1 black--text">
            {{ employee.email }}<br>
          </div>

          <div class="body-3 black--text" style="margin-top: 20px ">
            <v-icon color="green darken-1">mdi-checkbox-marked-circle</v-icon>本人確認コードを再送します<br>
            <br>
            <v-icon color="red darken-1">mdi-alert-circle</v-icon>本人確認コードの有効期限は送信から24時間となっておりますのでご注意ください。<br>
            <br>
            本人確認コードを再送してもよろしいでしょうか<br>
          </div>
         </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            @click="isResendConfirmed = false"
          >
          キャンセル
          </v-btn>
          <v-btn
            rounded 
            color="amber darken-1" 
            @click="resendSignUp()" 
            class="px-2"
          >
          <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
          送信する
          </v-btn> 

      </v-card-actions>
    </v-card>
    </v-dialog>

    <v-dialog
      v-model="isDeptTransferConfirmed"
      persistent
      max-width="500"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline" id="card-title">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
          ご確認ください
          </v-card-title>
        <v-card-text>
          <div class="caption mb-3">
            ユーザー「{{ employee.Name }}」の部署異動を実行します。<br>
            以下から異動先を選択してください。
          </div>
          
          <div class="subtitle-2 mb-2">同じメールアドレスの担当者一覧</div>
          <div v-if="sameEmailEmployees.length === 0" class="text-center pa-4">
            <v-icon color="grey" large>mdi-account-off</v-icon>
            <div class="body-2 grey--text mt-2">異動先の担当者が見つかりません</div>
          </div>
          <v-list v-else dense>
            <v-list-item 
              v-for="emp in sameEmailEmployees" 
              :key="emp.id"
              @click="selectEmployee(emp)"
              :class="{ 'blue lighten-4': selectedEmployeeId === emp.id }"
            >
              <v-list-item-content>
                <v-list-item-title class="body-2">
                  {{ emp.CompanyName }} {{ emp.OfficeName }} {{ emp.DeptName }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            @click="isDeptTransferConfirmed = false"
          >
          キャンセル
          </v-btn>
          <v-btn
            v-if="sameEmailEmployees.length > 0"
            rounded 
            color="blue darken-1" 
            @click="deptTransfer()" 
            class="px-2"
            >
            <v-icon class="mr-2">mdi-account-switch</v-icon>
            異動する
          </v-btn> 
      </v-card-actions>
    </v-card>
    </v-dialog>


  <vali-dialog :valiErrorText="valiErrorText" ref="isErrored"></vali-dialog>
  <suc-dialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></suc-dialog>
  <app-dialog :failureUrl="failureUrl" ref="isFailured"></app-dialog>  
  <signupsucDialog :successText="successText" :username="signupName" :email="signupEmail" :password="initPassword" :sampleBody="sampleBody" ref="isSignupSuccessed"></signupsucDialog>
  </v-container>
</template>

<script>
import { API, graphqlOperation, Auth} from "aws-amplify"　// eslint-disable-line
import { getEmployee } from '../graphql/queries'
import { officeByKey, } from '../graphql/queries'
import { companyByKey, } from '../graphql/queries'
import { sortedCodesByType, } from '../graphql/queries'
import { employeeByEmail, } from '../graphql/queries'
import { configureByKey, } from '../graphql/queries'
import { updateEmployee, } from '../graphql/mutations'
import valiErrored from "../components/validateErrorDialog.vue"
import entSuccessed from "../components/successDialog.vue"
import isFailured from "../components/failureDialog.vue"
import signupSuccessed from "../components/sigunUpSuccessDialog"

export default {
  components:{
    valiDialog: valiErrored,
    sucDialog: entSuccessed,
    appDialog: isFailured,    
    signupsucDialog: signupSuccessed,    
  },
  head: {
    title: { inner: '担当者情報'},
  },
    data: () => ({
      OfficeID: "",
      isUserPooled: false,
      isConfirmed: false,
      isAllowConfirmed: false,
      isResendConfirmed: false,
      isDeptTransferConfirmed: false,
      sameEmailEmployees: [],
      selectedEmployeeId: null,
      overlayStepper1: true,   
      employeeid: "",
      employee: {},
      valiErrorText: 'メールアドレスのないユーザーは<br>利用許可できません。</p>',
      roles: [],
      role: "",
      rolename: "",
      doChangeRole: false,
      doTranfer: false,
      successText: '',
      successUrl: '/employeeList',
      failureUrl: '/employeeList',
      signupName: "",
      signupEmail: "",
      initPassword: "",
      sampleBody: "",
    }),
    computed: {
      // 設定可能なロール
      approvedRoles: function () {
        // 自分より小さいロールには変更させる
//        let _roles = this.roles.filter(item => item.Value <= this.$store.state.employee.Permission)
//        return _roles
        return this.roles
      },
      isAdmin () {
        return this.$store.state.isAdmin
      },
      isUserAdmin () {
        return this.$store.state.isUserAdmin
      },
      isSystemAdmin () {
        return this.$store.state.isSystemAdmin
      },
    },
    methods: {
      async beforeUpdateRole() {  
        console.log('role',this.role)  
        const selectrole = this.roles.filter(item => item.Value  == this.role)
        this.rolename = selectrole[0].Text
        this.isAllowConfirmed=true
      },
      async beforeDeptTransfer() {
        // 同じメールアドレスの担当者を検索（表示中の担当者を除外）
        try {
          let result = await API.graphql(graphqlOperation(employeeByEmail, {email: this.employee.email}))
          this.sameEmailEmployees = result.data.employeeByEmail.items.filter(emp => emp.id !== this.employee.id)
          this.selectedEmployeeId = null
          this.isDeptTransferConfirmed = true
        } catch (error) {
          console.log('employeeByEmail error: ', error)
          this.$refs.isFailured.open();
        }
      },
      selectEmployee(emp) {
        this.selectedEmployeeId = emp.id
      },
      async deptTransfer() {
        if (!this.selectedEmployeeId) {
          this.valiErrorText = '異動先を選択してください。'
          this.$refs.isErrored.open();
          return
        }
        
        this.isDeptTransferConfirmed = false
        
        try {
          const selectedEmp = this.sameEmailEmployees.find(emp => emp.id === this.selectedEmployeeId)
          
          // 1. 選択した異動先の担当者の情報を更新（現在の担当者の権限・UserPoolIDで更新）
          const targetEmployeeUpdate = {
            id: selectedEmp.id,
            Permission: this.employee.Permission,
            UserPoolID: this.employee.UserPoolID
          }
          
          await API.graphql(graphqlOperation(updateEmployee, {input: targetEmployeeUpdate}))
          console.log('異動先担当者の更新成功: ', targetEmployeeUpdate)
          
          // 2. 現在の担当者を無効化
          const currentEmployeeUpdate = {
            id: this.employee.id,
            Permission: '00000001',
            UserPoolID: '000000000'
          }
          
          await API.graphql(graphqlOperation(updateEmployee, {input: currentEmployeeUpdate}))
          console.log('現在の担当者の無効化成功: ', currentEmployeeUpdate)
          
          this.successText = `担当者の部署異動が完了しました。<br>異動先: ${selectedEmp.CompanyName} ${selectedEmp.OfficeName} ${selectedEmp.DeptName}`
          this.$refs.isSuccessed.open();
          
        } catch (error) {
          console.log('部署異動エラー: ', error)
          this.valiErrorText = '部署異動処理中にエラーが発生しました。'
          this.$refs.isErrored.open();
        }
      },
      async updateRole() {
        this.isAllowConfirmed=false
        const employee = {
          id: this.employee.id,
          Permission: this.role
        }
        try {
          let _employee = await API.graphql(graphqlOperation(updateEmployee, {input: employee}))
          console.log('updateRole success: ', _employee)
          this.successText = '担当者の権限が変更されました。<br>変更を反映するためにログアウトして再ログインしてください。'
          this.$refs.isSuccessed.open();
        } catch (error) {
          console.log('updateRole error: ', error)
          this.$refs.isFailured.open();
        }
      },

      async resendSignUp() {
        try {
            this.isResendConfirmed = false
            await Auth.resendSignUp(this.employee.email);
            console.log('code resent successfully');
            this.successText = this.employee.email + ' に本人確認コードを送信しました。<br>' + this.employee.Name + '様にご連絡してください'
            this.$refs.isSuccessed.open();
        } catch (err) {
            console.log('error resending code: ', err);
            if(err.code == "LimitExceededException") {
              this.valiErrorText = this.employee.Name + " 本人確認コードの再送ができませんでした<br><br>"
              this.valiErrorText = this.valiErrorText + "再送の上限回数を超えました。<br>"
              this.valiErrorText = this.valiErrorText + "しばらくお時間をおいてから再実行してください。<br>"
              this.valiErrorText = this.valiErrorText + "<br>"
              this.valiErrorText = this.valiErrorText + "メールアドレス：" + this.employee.email +"</p>"
              this.valiErrorText = this.valiErrorText + "</p>"
            }else if(err.code == "InvalidParameterException") {
              this.valiErrorText = this.employee.Name + " 本人確認済みです<br><br>"
              this.valiErrorText = this.valiErrorText + "本人確認コードを送信しませんでした<br>"
              this.valiErrorText = this.valiErrorText + "</p>"            
            }else {
              this.valiErrorText = this.employee.Name + " 本人確認コードの再送ができませんでした<br><br>"
              this.valiErrorText = err.message + '<br>'
              this.valiErrorText = this.valiErrorText + "<br>"
              this.valiErrorText = this.valiErrorText + "メールアドレス：" + this.employee.email +"</p>"
            }
            this.$refs.isErrored.open(); 
         }
      },
      async signUp() {
        console.log("signup");

        // 同じメールアドレスで既に利用許可済み（UserPoolID設定済み）の担当者がいないか事前チェック
        // Cognito は未検証（UNCONFIRMED）の同一メール再サインアップをエラーにしないため、アプリ側で制御する
        if (this.employee.email) {
          try {
            const dupResult = await API.graphql(graphqlOperation(employeeByEmail, {email: this.employee.email}))
            const duplicated = dupResult.data.employeeByEmail.items.filter(emp => emp.id !== this.employee.id && emp.UserPoolID && emp.UserPoolID !== '000000000')
            if (duplicated.length > 0) {
              this.valiErrorText = this.employee.Name + " 様の利用を許可できませんでした。<br><br>"
              this.valiErrorText = this.valiErrorText + "既に同じメールアドレスで利用開始されている担当者がいます。（E0001）<br>"
              this.valiErrorText = this.valiErrorText + "メールアドレスをご確認いただくか、システム管理者に連絡して下さい<br>"
              this.valiErrorText = this.valiErrorText + "メールアドレス：" + this.employee.email + "</p>"
              this.$refs.isErrored.open();
              return
            }
          } catch (dupError) {
            console.log('employeeByEmail (duplicate check) error: ', dupError)
            this.$refs.isFailured.open();
            return
          }
        }

        var letters = 'abcdefghijklmnopqrstuvwxyz';
        var numbers = '0123456789';
        var string  = letters + letters.toUpperCase() + numbers;

        var len = 8; //8文字
          var password='';

        // パスワードがポリシーに適合するまで繰り返し
        for (;;) {
          password='';
          for (var i = 0; i < len; i++) {
            password += string.charAt(Math.floor(Math.random() * string.length));
          }
          console.log(password);
          var regex = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[A-Za-z\d@$*.!@#.:_~]{8,100}$/;
          
          var result = regex.test(password);
          if(result == true) {
            console.log("valid password");
            break
          }else {
            console.log("invalid password!!!!! reGenerate");
          }
        } 
        
        if (!this.employee.email) {
          console.log("email error");
          this.$refs.isErrored.open();          
        }
        this.isConfirmed=false

        this.sampleBody = ""
        this.sampleBody = this.sampleBody + this.employee.CompanyName + " " + this.employee.OfficeName + " " + this.employee.DeptName + "\n"
        this.sampleBody = this.sampleBody + this.employee.Name + " 様\n"
        this.sampleBody = this.sampleBody + "\n"
        this.sampleBody = this.sampleBody + "この度は、弊社の「OilMatrix ジャパン・アナリスト™」にご登録いただきありがとうございます。 \n"
        this.sampleBody = this.sampleBody + "本サービスの仮登録が完了いたしましたのでお知らせいたします。 \n"
        this.sampleBody = this.sampleBody + "\n"
        this.sampleBody = this.sampleBody + "利用開始にあたり、以下の手順でユーザアカウントの本登録いただきますようお願いいたします。 \n"
        this.sampleBody = this.sampleBody + "なお、本人確認コードは24時間で無効となりますのでお早めの本登録をお願いいたします。 \n"
        this.sampleBody = this.sampleBody + "利用開始の詳細な手順は以下をご確認ください。 \n"
        this.sampleBody = this.sampleBody + "https://www.japan-analysts.com/oilmatrix/howtosignup.pdf \n"
        this.sampleBody = this.sampleBody + "\n\n"
        this.sampleBody = this.sampleBody + "（１）「本人確認コード」の確認\n"
        this.sampleBody = this.sampleBody + "　「本人確認コード」が「OilMatrix ジャパン・アナリスト「本人確認コード」のご連絡」という件名のメールが届きますので確認してください。\n"
        this.sampleBody = this.sampleBody + "　本文の「あなたの本人確認コードは xxxxxxx です。」xxxxxxxが本人確認コードです。\n"
        this.sampleBody = this.sampleBody + "\n"
        this.sampleBody = this.sampleBody + "（２）OilMatrix ジャパン・アナリストにアクセスする\n"
        this.sampleBody = this.sampleBody + "　「OilMatrix ジャパン・アナリスト」にアクセスしてください。\n"
        this.sampleBody = this.sampleBody + "　URL: https://adws.japan-analysts.com\n"
        this.sampleBody = this.sampleBody + "\n"
        this.sampleBody = this.sampleBody + "（３）初期パスワードでログインする\n"
        this.sampleBody = this.sampleBody + "　初期パスワードを以下に設定しておりますので、ご本人のメールアドレス（このメールアドレス）でログインしてください。\n"
        this.sampleBody = this.sampleBody + "　メールアドレス　" + this.employee.email + "\n"
        this.sampleBody = this.sampleBody + "　初期パスワード　" + password + "\n"
        this.sampleBody = this.sampleBody + "\n"
        this.sampleBody = this.sampleBody + "（４）パスワードの再設定\n"
        this.sampleBody = this.sampleBody + "　「本人確認コード」と、新しいパスワードを入力して本登録を完了して下さい。\n"
        this.sampleBody = this.sampleBody + "\n\n"
        this.sampleBody = this.sampleBody + "このメールは、「OilMatrix ジャパン・アナリスト」にご登録いただいた方にお送りしております。\n"
        this.sampleBody = this.sampleBody + "内容にお心当たりがない場合は、登録およびメールの配信を停止いたしますので、お手数ですが本メールにご返信ください \n" 

        //サインアップ処理
        //------------------------------------------------------------------------------------------
        let signUpData
        try {
          signUpData = await Auth.signUp({
            username: this.employee.email,
            password: password,
            name: this.employee.Name,
          })
          console.log("signup user:", signUpData)
          console.log("signup user id:", signUpData.userSub)
        } catch (err) {
          console.log("signup err:", err);
          if(err.code == "UsernameExistsException") {
            this.valiErrorText = this.employee.Name + " 様の利用を許可できませんでした。<br><br>"
            this.valiErrorText = this.valiErrorText + "既に同じメールアドレスで利用開始されている担当者がいます。（E0002）<br>"
            this.valiErrorText = this.valiErrorText + "メールアドレスをご確認いただくか、システム管理者に連絡して下さい<br>"
            this.valiErrorText = this.valiErrorText + "メールアドレス：" + this.employee.email +"</p>"
            this.valiErrorText = this.valiErrorText + "</p>"
          }else {
            this.valiErrorText = this.employee.Name + " 様の利用を許可できませんでした。<br>"
            this.valiErrorText = err.message + '</p>'
            this.valiErrorText = this.valiErrorText + "メールアドレス：" + this.employee.email +"</p>"
          }
          this.$refs.isErrored.open();
          // サインアップに失敗した場合は、後続の成功ダイアログ・招待メール送信を行わない
          return
        }
        //------------------------------------------------------------------------------------------

        // poolIDの更新処理（サインアップ成功時のみ）
        //------------------------------------------------------------------------------------------
        try {
          const employee = {
            id: this.employee.id,
            UserPoolID: signUpData.userSub,
            Permission: '10000001'
          }
          let _employee = await API.graphql(graphqlOperation(updateEmployee, {input: employee}))
          console.log('updateRole success: ', _employee)
          this.successText = '利用確認のためのメールを ' + this.employee.email + ' に送信しました。<br>「' + this.employee.Name + '」様に初期パスワードを連絡をしてください。<br><br>初期パスワード：'+ password
          this.signupName = this.employee.Name
          this.signupEmail = this.employee.email
          this.initPassword = password
          this.$refs.isSignupSuccessed.open();
        } catch (error) {
          console.log('updateRole error: ', error)
          this.$refs.isFailured.open();
          // Employee 更新に失敗した場合は、招待メール送信を行わない
          return
        }
        //------------------------------------------------------------------------------------------

        // メール送信処理
        // バックグラウンドメール送信テーブルに招待メールを登録
        try {
          // Configure テーブルから signup_notice_mail_from を取得
          let signupMailFrom = "info@adws.japan-analysts.com" // デフォルト値
          try {
            const configResult = await API.graphql(graphqlOperation(configureByKey, {Key: "signup_notice_mail_from"}))
            if (configResult.data.configureByKey.items.length > 0) {
              signupMailFrom = configResult.data.configureByKey.items[0].Value
            }
          } catch (configError) {
            console.log('Configure取得エラー:', configError)
          }
          
          let signupMailCC = this.$store.state.employee.email

          const outboxData = {
            From: signupMailFrom,
            To: this.employee.email,
            CC: signupMailCC,
            Subject: "【ご確認ください】ジャパン・アナリスト　「OilMatrix ジャパン・アナリスト」仮登録完了のお知らせ",
            Body: this.sampleBody,
            Status: "PENDING",
            Type: "SIGNUP",
          }
          
          const { createOutbox } = await import('../graphql/mutations')
          await API.graphql(graphqlOperation(createOutbox, { input: outboxData }))
          console.log('Outbox entry created successfully')
        } catch (error) {
          console.log('Outbox creation error:', error)
        }


      }
    },
    mounted: async function () {
      //管理者権限を持っている場合のみ表示を許可
      if(this.$store.state.isAdmin) {
        console.log('employee id: ', this.$route.query.id)
        this.employeeid = this.$route.query.id
        let employee = await API.graphql(graphqlOperation(getEmployee, {id: this.employeeid}))
        this.employee = employee.data.getEmployee

        let officeid = this.employee.OfficeID
        let _office = await API.graphql(graphqlOperation(officeByKey, {OfficeID: officeid}))
        let office = _office.data.officeByKey.items[0]

        let companyid = this.employee.CompanyID
        let _company = await API.graphql(graphqlOperation(companyByKey, {CompanyID: companyid}))
        let company = _company.data.companyByKey.items[0]

        // 企業名、事業所名の変更は担当者（Employee）連携時に反映されない
        // 各マスタの名称で上書きする
        this.employee["OfficeName"] = office.Name
        this.employee["CompanyName"] = company.Name

        if (this.employee.Permission == "00000001") {
          this.isUserPooled = true
        }

        let _roles = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: "role"}))
        this.roles = _roles.data.sortedCodesByType.items
        this.role = this.employee.Permission
/*
        //システム管理者は、対象がシステム管理者の権限変更を許可
        if (this.$store.state.isSuperUser && this.role == "99999999") {
          this.doChangeRole = true
        //システム管理者でない管理者は、対象がシステム管理者の場合は権限変更を不許可
        }else if(!this.$store.state.isSuperUser && this.role == "99999999"){
          this.doChangeRole = false
        //対象がシステム管理者でない場合は変更を許可
        }else {
          this.doChangeRole = true
        }
*/
        this.overlayStepper1 = false

        // スーパーユーザーは権限変更と部署異動を許可
        if (this.$store.state.isSuperUser) {
          this.doTranfer= true
          this.doChangeRole = true
        }
      }
    },
}
</script>
